<template>
    <div>
        <v-row :no-gutters="$vuetify.breakpoint.xsOnly">
            <v-col cols="12" sm="6" style="flex-wrap:nowrap">
                <DatePicker :label="$t('Дата с')" class="d-inline-block mr-15 date-picker" v-model="indicationDateBegin" :clearable="false" />
                <DatePicker :label="$t('Дата по')" class="d-inline-block date-picker" v-model="indicationDateEnd" :clearable="false" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-radio-group v-model="meterIndicationsFilter.tab" hide-details class="nowrap-radio-group" :row="$vuetify.breakpoint.smAndUp">
                    <v-radio :label="$t('Введенное потребление')" :value="1" class="mr-15"></v-radio>
                    <v-radio :label="$t('Потребление по услугам')" :value="2"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import DatePicker from '../../../components/ui/DatePicker';
export default {
    components: {
        DatePicker
    },
    computed: {
        ...mapState('meters', ['meterIndicationsFilter', 'meterIndicationsOptions']),
        indicationDateBegin: {
            get() {
                return this.$store.getters['meters/indicationDateBegin'];
            },
            set(value) {
                this.meterIndicationsFilter.dateBegin = value;
                this.getMeterIndicaitonsLocal();
            }
        },
        indicationDateEnd: {
            get() {
                return this.$store.getters['meters/indicationDateEnd'];
            },
            set(value) {
                this.meterIndicationsFilter.dateEnd = value;
                this.getMeterIndicaitonsLocal();
            }
        }
    },
    methods: {
        ...mapActions('meters', ['getMeterIndicaitons']),
        getMeterIndicaitonsLocal() {
            this.meterIndicationsOptions.pagination.page = 1;
            this.getMeterIndicaitons(this.$parent.id);
        }
    },
    created() {
        this.$store.commit('meters/setMeterIndications', []);
        this.meterIndicationsOptions.pagination = {
            pagination: {},
            size: -1,
            loading: false
        };
        this.meterIndicationsFilter.dateBegin = '';
        this.meterIndicationsFilter.dateEnd = '';
        this.meterIndicationsFilter.tab = 1;
    }
};
</script>
<style>
.date-picker {
    max-width: 170px;
}
</style>
